import { useState } from "react";
import DeleteWarning from "./Modals/deleteWarning";
import { IoIosCloseCircle } from "react-icons/io";
import RemoveManager from "./Modals/removeManager";
import TerritoryTable from "./territoryTable";
import { useSelector } from "react-redux";

const HierarchyTree = ({ territoryList, setCreateTerritoryFrom, setIsShowNewCreationUI, handleDeleteTerritory, setIsCreate, setSelectedTerritoryToEdit, handleRemoveTerritoryManager, handleChangeTerritoryManager, showTreeNode }) => {
    let allUsers = useSelector((state) => state?.user)?.allUserData;

    let [selectedDataToDelete, setSelectedDataToDelete] = useState()
    let [showDeleteWarningModal, setShowDeleteWarningModal] = useState(false)

    let [selectedDataToRemoveManager, setSelectedDataToRemoveManager] = useState();
    let [showRemoveManagerWarningModal, setShowRemoveManagerWarningModal] = useState(false)

    let [selectedDataToChangeManager, setSelectedDataToChangeManager] = useState()
    let [showTerritaryTable, setShowTerritoryTable] = useState(false)

    const handleDelete = (child) => {
        setSelectedDataToDelete(child)
        setShowDeleteWarningModal(true)
    }

    const handleRemoveManager = (child) => {
        setSelectedDataToRemoveManager(child)
        setShowRemoveManagerWarningModal(true)
    }

    const handleSelectManager = (value) => {
        handleChangeTerritoryManager(
            selectedDataToChangeManager,
            { id: value._id, name: `${value?.firstName} ${value?.lastName}` }
        )
        // setTerritoryData((prev) => ({
        //     ...prev,
        //     territory_manager: {
        //         name: `${value.firstName} ${value.lastName}`,
        //         id: value._id
        //     }
        // }));
    }

    const groupByParentId = (territories) => {
        const obj = {};
        territories?.forEach(territory => {
            const key = territory.parent_territory?.id || "null";
            if (!obj[key]) obj[key] = [];
            obj[key].push(territory);
        });
        return obj;
    };

    let result = groupByParentId(territoryList);

    const TreeNode = (parentId, isInitial = false) => {
        let data = result[parentId] || [];
        return (
            <ul className={isInitial ? "tree mt-3" : "nested-list"}>
                {data?.map(child => (
                    <li className={isInitial ? "parent" : "nested-item"} key={child._id}>
                        <div className="d-inline-block ps-4 role-name-box cursor-pointer">
                            {child.territory_name}
                            {!isInitial && child?.territory_manager &&
                                <span className="territory-hover">{child?.territory_manager?.name}
                                    <IoIosCloseCircle className="ms-1 territory-hover-icon" style={{ color: '#0d6efd' }} onClick={() => handleRemoveManager(child)} />
                                </span>
                            }
                            {isInitial ?
                                <span className="label action-btns border-0">
                                    <span className="act-btn add-btn rounded-pill cursor-pointer" role="button" title="Create New Territory"
                                        onClick={() => { setIsCreate(true); setCreateTerritoryFrom(child._id); setIsShowNewCreationUI(true) }}>
                                        <i className="fas fa-plus"></i>
                                    </span>
                                    <span className="act-btn edit-btn rounded-pill cursor-pointer" role="button" title="Edit Territory"
                                        onClick={() => { setIsCreate(false); setSelectedTerritoryToEdit(child); setIsShowNewCreationUI(true) }}>
                                        <i className="fas fa-pencil"></i>
                                    </span>
                                </span> :
                                <span className="label action-btns border-0">
                                    <span className="act-btn add-btn rounded-pill cursor-pointer" role="button" title="Change Manager"
                                        onClick={() => { setSelectedDataToChangeManager(child); setShowTerritoryTable(true) }}>
                                        <i className="fa-solid fa-user"></i>
                                    </span>
                                    <span className="act-btn add-btn rounded-pill cursor-pointer" role="button" title="Create New Territory"
                                        onClick={() => { setIsCreate(true); setCreateTerritoryFrom(child._id); setIsShowNewCreationUI(true) }}>
                                        <i className="fas fa-plus"></i>
                                    </span>
                                    <span className="act-btn edit-btn rounded-pill cursor-pointer" role="button" title="Edit Territory"
                                        onClick={() => { setIsCreate(false); setSelectedTerritoryToEdit(child); setIsShowNewCreationUI(true) }}>
                                        <i className="fas fa-pencil"></i>
                                    </span>
                                    <span className="act-btn delete-btn rounded-pill cursor-pointer" role="button" title="Delete Territory"
                                        onClick={() => handleDelete(child)}>
                                        <i className="fas fa-trash"></i>
                                    </span>
                                </span>
                            }
                        </div>
                        {result[child._id] && (
                            <details open={showTreeNode} className="details">
                                <summary></summary>
                                {TreeNode(child._id)}
                            </details>
                        )}
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <>
            <div>{TreeNode("null", true)}</div>
            {showDeleteWarningModal &&
                <DeleteWarning
                    showDeleteWarningModal={showDeleteWarningModal}
                    setShowDeleteWarningModal={setShowDeleteWarningModal}
                    selectedDataToDelete={selectedDataToDelete}
                    setSelectedDataToDelete={setSelectedDataToDelete}
                    handleDeleteTerritory={handleDeleteTerritory}
                />
            }
            {showRemoveManagerWarningModal &&
                <RemoveManager
                    showRemoveManagerWarningModal={showRemoveManagerWarningModal}
                    setShowRemoveManagerWarningModal={setShowRemoveManagerWarningModal}
                    selectedDataToRemoveManager={selectedDataToRemoveManager}
                    setSelectedDataToRemoveManager={setSelectedDataToRemoveManager}
                    handleRemoveTerritoryManager={handleRemoveTerritoryManager}
                />
            }
            {showTerritaryTable &&
                <TerritoryTable
                    isOpen={showTerritaryTable}
                    onClose={setShowTerritoryTable}
                    onUserSelect={handleSelectManager}
                    allUsers={allUsers}
                    changeManager={true}
                    selectedDataToChangeManager={selectedDataToChangeManager}
                />
            }
        </>
    )
}
export default HierarchyTree